import { ShowToast } from "@Components/ToastNotification/ToastNotification"
import { EducatifDiagnoseService } from "@Services/EducatifDiagnose.Service"
import { LocalStorage } from "@Services/sharedPreferences/localStorage"
import { UserService } from "@Services/User.service"

const hasStartedSurvey = (setLoading, handleRedirect) => {
    setLoading?.(true)
    LocalStorage.getSurveyResponse().then((response) => {
        if (response) {
            handleRedirect?.()
        }
        setLoading?.(false)
    })
}

const fetchEducationalDiagnosis = ({
    setLoading,
    user,
    setCurrentEducationalDiagnosis,
    handleRedirect,
    isDiagnosticScreen,
    handleExpiredToken
}) => {
    setLoading?.(true)

    EducatifDiagnoseService.getAlldiagnosis(user?.id)
        .then((response) => {
            const data = response.data?.data
            setCurrentEducationalDiagnosis(data)
            if (isDiagnosticScreen) {
                if (data) {
                    handleRedirect?.()
                } else {
                    hasStartedSurvey(setLoading, handleRedirect)
                }
            }
            setLoading?.(false)
        })
        .catch((e) => {
            setLoading?.(false)
            console.log({ errorFetchingDE: e })
            if (e?.response?.data?.code === 401) {
                handleExpiredToken?.()
            }
            ShowToast({ type: "error", message: "Problème lors de la récuperation du DE" })
        })
}

const fetchNotificationStatus = ({ pushToken, setPushToken }) => {
    UserService.getNotificationToken()
        .then((response) => {
            const data = response.data?.data

            if (data.length > 0) {
                if (data.includes(pushToken)) {
                    setPushToken(pushToken)
                } else {
                    setPushToken(null)
                }
            } else {
                setPushToken(null)
            }
        })
        .catch((e) => {
            ShowToast({ type: "error", message: "Error getting notification token" })
        })
}

const fetchUserData = ({ setUser, navigation }) => {
    UserService.getUserData()
        .then((response) => {
            const data = response.data.data
            if (data) {
                setUser(data)
                LocalStorage.saveUser(data)
            }
        })
        .catch((e) => {
            if (e?.response?.data?.status === 401 || e.response?.status === 401) {
                setUser(null)
                LocalStorage.clearAll().then(() => {
                    navigation.navigate("Root", { screen: "RegisterLoginStack", params: { screen: "LoginStack" } })
                })
            }
        })
}

const loadLocalData = async ({ setResponsesSurvey }) => {
    const localSurveyResponses = await LocalStorage.getSurveyResponse()
    if (localSurveyResponses) {
        setResponsesSurvey(localSurveyResponses)
    }
}

const fetchUserDEList = (userId, setEducationalDiagnosisList) => {
    EducatifDiagnoseService.getUserDEList(userId)
        .then((res) => {
            const data = res?.data?.data
            setEducationalDiagnosisList(data)
        })
        .catch(() => {})
}

export { fetchUserDEList, fetchUserData, fetchEducationalDiagnosis, fetchNotificationStatus, hasStartedSurvey }
